/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatchDispensingRequestBodyTypename = "PatchDispensingRequestBody" as const;

/**
 *
 * @export
 * @interface PatchDispensingRequestBody
 */
export interface PatchDispensingRequestBody {
  /**
   *
   * @type {string}
   * @memberof PatchDispensingRequestBody
   */
  dispensingCompletedMessage?: string;
  /**
   *
   * @type {string}
   * @memberof PatchDispensingRequestBody
   */
  status: PatchDispensingRequestBodyStatusEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatchDispensingRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatchDispensingRequestBodyStatusEnum {
  Dispensed = "dispensed",
  Notified = "notified",
}

export function PatchDispensingRequestBodyFromJSON(json: any): PatchDispensingRequestBody {
  return PatchDispensingRequestBodyFromJSONTyped(json, false);
}

export function PatchDispensingRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchDispensingRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatchDispensingRequestBodyTypename,

    dispensingCompletedMessage: !exists(json, "dispensing_completed_message")
      ? undefined
      : json["dispensing_completed_message"],
    status: json["status"],
  };
}

export function PatchDispensingRequestBodyToJSON(object?: PatchDispensingRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    dispensing_completed_message: value.dispensingCompletedMessage,
    status: value.status,
  };
}
